/*
  Black Friday 2026: one shared clock for the sale (Perth time, +08:00).
  Loaded (deferred) by layout/theme.liquid only when settings.bf_enabled.

  Reads html[data-bf-end] and html[data-bf-final]; "now" is window.bfNow() from the head script
  (real time, or the moving preview clock the theme setting picks). Every second, anywhere in the page:
    [data-bf-left]       "12 days left" / "1 day left" / "Last day" / "Sale ended"
    [data-bf-days]       12 (or "Last")
    [data-bf-days-u]     "days left" / "day left" / "day"
    [data-bf-fu="d|h|m|s"] two-digit parts of the time left to the end
    [data-bf-live]       gets the hidden attribute once the sale has ended
  and keeps html[data-bf-phase] current: on | final (from data-bf-final) | ended (after data-bf-end).
  Days = floor((end - now) / 86 400 000), so the count drops at midnight Perth time.
  It pauses while the tab is hidden and re-runs on shopify:section:load.
  window.bfRefresh() fills newly added markup straight away.
*/
(function () {
  'use strict';

  if (window.bfRefresh) return;

  var html = document.documentElement;
  var DAY = 86400000;
  var SELECTOR = '[data-bf-left],[data-bf-days],[data-bf-days-u],[data-bf-fu],[data-bf-live]';
  var timer = null;

  // ISO date-time; a space for the T and a missing offset are read as Perth time.
  function parse(value) {
    var text = String(value || '').trim().replace(' ', 'T');
    if (/T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(text)) text += '+08:00';
    return Date.parse(text);
  }

  function now() {
    return typeof window.bfNow === 'function' ? window.bfNow() : Date.now();
  }

  function two(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function tick() {
    var end = parse(html.getAttribute('data-bf-end'));
    var finalFrom = parse(html.getAttribute('data-bf-final'));
    var t = now();
    var ended = !(t < end); // matches the server gate, including invalid end dates
    var phase = ended ? 'ended' : t >= finalFrom ? 'final' : 'on';

    // The normal announcement slides are rendered into an inert template during the sale.
    // Swap the complete carousel so its slide count, arrows and autoplay stay correct.
    if (ended) {
      document.querySelectorAll('[data-bf-announcement-fallback]').forEach(function (template) {
        var current = template.previousElementSibling;
        if (current && current.hasAttribute('data-bf-campaign-announcements')) current.remove();
        template.replaceWith(template.content.cloneNode(true));
      });
    }

    var previousPhase = html.getAttribute('data-bf-phase');
    if (previousPhase !== phase) {
      html.setAttribute('data-bf-phase', phase);
      // The ordinary homepage sections become visible again without a reload.
      // Let their responsive components recalculate the newly available space.
      if (phase === 'ended') document.dispatchEvent(new CustomEvent('window:resize'));
    }

    var left = ended ? 0 : end - t;
    var days = Math.floor(left / DAY);
    var leftText = ended ? 'Sale ended' : days > 1 ? days + ' days left' : days === 1 ? '1 day left' : 'Last day';
    var daysText = days > 0 ? String(days) : 'Last';
    var unitText = days > 1 ? 'days left' : days === 1 ? 'day left' : 'day';

    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    s -= d * 86400;
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    var parts = { d: two(d), h: two(h), m: two(m), s: two(s) };

    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-bf-left')) setText(el, leftText);
      if (el.hasAttribute('data-bf-days')) setText(el, daysText);
      if (el.hasAttribute('data-bf-days-u')) setText(el, unitText);
      if (el.hasAttribute('data-bf-fu')) {
        var part = parts[el.getAttribute('data-bf-fu')];
        if (part) setText(el, part);
      }
      if (ended && el.hasAttribute('data-bf-live') && !el.hidden) el.hidden = true;
    }
  }

  // Tick on the second, and only while the page is visible
  function schedule() {
    clearTimeout(timer);
    if (document.hidden) return;
    var ms = now() % 1000;
    timer = setTimeout(function () {
      tick();
      schedule();
    }, 1000 - (ms < 0 ? ms + 1000 : ms) + 15);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
    schedule();
  });
  document.addEventListener('shopify:section:load', tick);

  window.bfRefresh = tick;
  tick();
  schedule();
})();
